import { FC } from 'react';
import { v4 as uuid } from 'uuid';
import './DashboardTabs.scss';

interface IDashboardTab {
  tabId: number;
  tabName: string;
}

interface IDashboardTabs {
  tabsList: IDashboardTab[];
  selectedTabId: number;
  handleChangeSelectedTabId: (newTabId: number) => void;
}

const DashboardTabs: FC<IDashboardTabs> = ({ tabsList, handleChangeSelectedTabId, selectedTabId }: IDashboardTabs) => {
  const generateTabs = (tabsList: IDashboardTab[]) => {
    return tabsList.map(tab => {
      return (
        <div
          key={uuid()}
          onClick={() => handleChangeSelectedTabId(tab.tabId)}
          className={`dashboardTab ${selectedTabId === tab.tabId ? 'selected' : ''}`}
        >
          <div className="tabName">{tab.tabName}</div>
        </div>
      );
    });
  };

  return <div className="DashboardTabs">{tabsList && tabsList.length > 0 && generateTabs(tabsList)}</div>;
};

export default DashboardTabs;
